import React from "react";
import { Dialog } from "primereact/dialog";
import { Rating } from "primereact/rating";
import Textarea from "./Textarea";
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { handleError } from "../utils/functions";
import { useTranslation } from "react-i18next";

const schema = yup.object().shape({
  rating: yup
    .number()
    .required("Rating is required")
    .min(1, "Rating must be at least 1")
    .max(5, "Rating must be at most 5"),
  review: yup.string().required("Review is required"),
});

const ReviewModal = ({ visible, setVisible, onSubmit }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    control,
    formState: { isSubmitting, errors },
    reset,
  } = useForm({ resolver: yupResolver(schema), mode: "all" });

  const submit = async (data) => {
    try {
      await onSubmit(data);
      reset();
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="p-5 bg-white rounded-10">
      <Dialog
        header={t("reviews")}
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        <form onSubmit={handleSubmit(submit)}>
          <div className="">
            <Controller
              name={"rating"}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <Rating
                  cancel={false}
                  pt={{
                    offIcon: { className: "review-stars" },
                    onIcon: { className: "review-stars review-stars-color" },
                    root: { className: "!gap-0" },
                  }}
                  onChange={(e) => field.onChange(e.value)}
                  value={field.value}
                  error={!!error}
                />
              )}
            />
            <div className="mt-20"></div>
            <Textarea
              name={"review"}
              register={register}
              error={errors.review}
              isRequired
              label={t("reviews")}
              placeholder={t("enterYourReview")}
              rows={5}
            />
          </div>
          <div className="d-flex justify-content-end">
            <button className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? t("submitting") : t("submitReview")}
            </button>
          </div>
        </form>
      </Dialog>
    </div>
  );
};

export default ReviewModal;
